package com.arena_web.ui.components.overlay

import androidx.compose.runtime.Composable
import com.arena_web.ui.components.events.PopupOverlayFadeIn
import com.arena_web.ui.theme.AppColors
import com.arena_web.ui.theme.AppGradients
import com.arena_web.ui.theme.AppTypography
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import org.jetbrains.compose.web.css.*

val ExpandScaleIn = Keyframes {
    from { Modifier.opacity(0).scale(0.85) }
    to { Modifier.opacity(1).scale(1) }
}

@Composable
fun ExpandModal(
    isOpen: Boolean,
    onClose: () -> Unit,
    title: String,
    content: @Composable () -> Unit
) {
    if (!isOpen) return

    // Overlay backdrop
    Box(
        modifier = Modifier
            .position(Position.Fixed)
            .top(0.px).left(0.px).right(0.px).bottom(0.px)
            .zIndex(1000)
            .backgroundColor(Color("rgba(0, 0, 0, 0.6)"))
            .onClick { onClose() }
            .animation(
                PopupOverlayFadeIn.toAnimation(
                    duration = Constants.ANIMATION_FAST.ms,
                    timingFunction = AnimationTimingFunction.EaseOut
                )
            ),
        contentAlignment = Alignment.Center
    ) {
        // Content container
        Column(
            modifier = Modifier
                .styleModifier {
                    property("width", "90vw")
                    property("height", "85vh")
                }
                .sBorderRadius(40)
                .overflow(Overflow.Hidden)
                .onClick { it.stopPropagation() }
                .animation(
                    ExpandScaleIn.toAnimation(
                        duration = 400.ms,
                        timingFunction = AnimationTimingFunction.cubicBezier(0.16, 1.0, 0.3, 1.0)
                    )
                )
                .styleModifier {
                    property("border", "1px solid transparent")
                    property(
                        "background",
                        "linear-gradient(202deg, rgba(60, 121, 241, 0.135) 37.5%, rgba(5, 4, 12, 0.03) 61.8%) padding-box, " +
                            "linear-gradient(0deg, var(--arena-bg), var(--arena-bg)) padding-box, " +
                            "${AppGradients.BorderInnerL} border-box"
                    )
                    property("box-shadow", "0 24px 64px rgba(0, 0, 0, 0.5)")
                }
        ) {
            // Header: title + close button
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .sPadding(20, 24)
                    .styleModifier {
                        property("border-bottom", "1px solid var(--l-hairline, rgba(255, 255, 255, 0.06))")
                        property("flex-shrink", "0")
                    },
                verticalAlignment = Alignment.CenterVertically
            ) {
                SpanText(
                    title,
                    modifier = Modifier
                        .sFontSize(24)
                        .fontWeight(AppTypography.Medium)
                        .sLetterSpacing(0.24)
                        .sLineHeight(32)
                        .color(com.arena_web.ui.theme.ThemeVars.Text2)
                        .flexGrow(1)
                )
                Box(
                    modifier = Modifier
                        .sSize(40)
                        .sBorderRadius(100)
                        .cursor(Cursor.Pointer)
                        .styleModifier {
                            property("background", "var(--arena-glass-strong)")
                        }
                        .onClick { onClose() },
                    contentAlignment = Alignment.Center
                ) {
                    SpanText(
                        "\u00D7",
                        modifier = Modifier
                            .sFontSize(24)
                            .color(com.arena_web.ui.theme.ThemeVars.Text2)
                    )
                }
            }

            // Scrollable content area
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .sPadding(24)
                    .styleModifier {
                        property("flex", "1 1 0px")
                        property("min-height", "0")
                        property("overflow-y", "auto")
                        property("scrollbar-width", "thin")
                        property("scrollbar-color", "rgba(255,255,255,0.15) transparent")
                    }
            ) {
                content()
            }
        }
    }
}
